import script from "./SupportFormButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportFormButton.vue?vue&type=script&setup=true&lang=ts"

import "./SupportFormButton.vue?vue&type=style&index=0&id=2436bcf1&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2436bcf1"]])

export default __exports__